import { render, staticRenderFns } from "./dot-spinner.vue?vue&type=template&id=2947c905&"
import script from "./dot-spinner.vue?vue&type=script&lang=js&"
export * from "./dot-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports